import {TEST_CALLS_DIALER as PREFIX} from '../../const';
import {ID} from '../../utils/helpers';
import {DEFAULT_PER_PAGE_DIALER} from '../../const';

const initialState = {
    loading: false,
    test_calls_list: [],
    count: 0,
    page: 1,
    per_page: DEFAULT_PER_PAGE_DIALER
};


const handlers = {
    ['SET_ITEMS_' + PREFIX]: (state, {payload: {cdr_full_test_list = [], cdr_full_test_count = 0, page, per_page}}) => ({
        ...state,
        test_calls_list: [
            ...cdr_full_test_list.map(x => {
                x.id = ID();
                return x;
            })
        ],
        loading: false,
        count: cdr_full_test_count,
        page,
        per_page
    }),
    ['SET_LOADING_' + PREFIX]: (state, {payload}) => ({...state, loading: payload}),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};
